/**
 * Expand Vue prototype with usefull features
 * @param {Object} Vue
 */

export default function(Vue) {
  const dateToTime = (time, settings = {}) => {
    const date = new Date(time);
    const hours =
      date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    const minutes =
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    if (settings.showSeconds) {
      const seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return `${hours}:${minutes}:${seconds}`;
    }
    return `${hours}:${minutes}`;
  };
  Vue.prototype.$dateToTime = dateToTime;

  Vue.prototype.$numberWithDots = x =>
    x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
